/**
 * Returned from each NavTreeNode action
 */
import {
    NAV_TARGET_DASHBOARD_TAB,
    NAV_TARGET_MANAGE_TAB,
    // NAV_TARGET_MANAGE_TAB,
    NAV_TARGET_OVERVIEW,
} from 'app/shared/internal_navigation/nav_targets';
import { k_SHOW_OVERVIEW } from 'app/main/PanesService';

export interface NavResult {
    // Amount of time to add onto the final delay amount in milliseconds, after all of the
    // navigation actions are complete but before any tour starts
    delay: number;
    // string with which to suffix all of the targets in the tour steps
    targetSuffix?: string;
}

interface NavTreeNode {
    action: () => NavResult;
    navLookup?: { [key: string]: NavTreeNode };
}

/**
 * An attempt to make something a little more generic to navigate to different
 * parts of the application. It's pretty messy right now. Could do with some refinement.
 */
export class NavTree {
    private _navLookupRoot: { [key: string]: NavTreeNode };

    constructor(panesService, overviewService) {
        // Create a tree structure that describes the traversal operations
        this._navLookupRoot = {
            [NAV_TARGET_OVERVIEW]: {
                action: () => {
                    const delay = panesService.state.getState()[k_SHOW_OVERVIEW] ? 0 : 1000;
                    panesService.showOverview();
                    return {
                        delay: delay,
                    };
                },
                navLookup: {
                    [NAV_TARGET_DASHBOARD_TAB]: {
                        action: () => {
                            // TODO using a const exported from the OverviewService here caused a circular dependency and an error :(
                            overviewService.state.effects.setOverviewTab('dashboard');
                            return null;
                        },
                        navLookup: {},
                    },
                    [NAV_TARGET_MANAGE_TAB]: {
                        action: () => {
                            overviewService.state.effects.setOverviewTab('manage');
                            return null;
                        },
                        navLookup: {},
                    },
                },
            },
        };
    }

    /**
     *
     * @param {string[]} navPath e.g. [NAV_TARGET_OVERVIEW, NAV_TARGET_DASHBOARD_TAB]
     * @returns {number} milliseconds to delay after navigation
     */
    navigate(navPath: string[]): NavResult {
        let navResult: NavResult = {
            delay: 0,
        };
        let navLookup = this._navLookupRoot;
        navPath.forEach((navTarget) => {
            const nextNode = navLookup[navTarget];
            if (!nextNode) {
                throw new Error(`Could not find nav node for ${navTarget}`);
            }
            const nextNavResult = nextNode.action();
            if (nextNavResult) {
                navResult.delay += nextNavResult.delay;
                // If the next action has assigned a target suffix, use it!
                navResult.targetSuffix =
                    nextNavResult.targetSuffix !== undefined
                        ? nextNavResult.targetSuffix
                        : navResult.targetSuffix;
            }
            navLookup = nextNode.navLookup;
        });
        return navResult;
    }
}
